import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Layout from "../Layout/Layout";
import CharteredOrdersList from "./CharteredOrdersList";
import { CallApiGet, CallApiPost } from "../Helper/serviceApi";
import CharteredPlanning from "./CharteredPlanning";
import moment from "moment";
import {
  BLACK_SPCL_CHARS,
  CH_NAV_TYPE,
  DATE_FORMAT_CLIENT,
  DATE_FORMAT_MOMENT,
  DATE_FORMAT_SERVER,
} from "../Helper/Constants";
import {
  CHBKNG,
  LINEHAUL_CUSTOMER_USER_TYPE_LIST,
  ORD_STS,
  ORDER_TYPE,
} from "../../ConfigConstants/ConfigConstants";
import { getUserInfo } from "../AuthUtils/AuthUtils";
import ReactDatePicker from "react-datepicker";
import GetSvgIcon from "../../images/svglist";
import ModalConfirmAlert from "../Layout/ModalConfirmAlert";
import CharteredDeliveryEventLog from "./CharteredDeliveryEventLog";
import {
  deliveryEventlogChartered,
  getKiplForm,
  permissionCheck,
} from "../Helper/CommonMethods";
import CharteredRateSummary from "../OrderBooking/ChartaredOrderBooking/CharteredRateSummary";
import { API_URI } from "../../ConfigConstants/UrlConstants";
import OrderCancellationLog from "../OrderManagement/OrderCancellationLog";

const initDropDownOpt = {
  drArr: [],
  vhclArr: [],
  sbuArr: [],
};

const initAlertConfig = {
  isSuccess: false,
  size: "",
  show: false,
  title: "",
  description: "",
};

const initConfirmAlert = {
  size: "md",
  show: false,
  title: "",
  description: "",
};

const initCancelReason = {
  value: "",
  error: false,
};

const CharteredOrdersMain = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [dropDownOpt, setDropDownOpt] = useState(
    Object.assign({}, initDropDownOpt)
  );

  const [showSpinner, setShowSpinner] = useState(false);
  const [showPlan, setShowPlan] = useState(false);
  const [charteredList, setCharteredList] = useState([]);
  const [selOrder, setSelOrder] = useState({});
  const [alertConfig, setAlertConfig] = useState(
    Object.assign({}, initAlertConfig)
  );
  const [searchType, setSearchType] = useState("Shipment");
  const [fromDate, setFromDate] = useState(
    moment().subtract(1, "months").format(DATE_FORMAT_SERVER)
  );
  const [toDate, setToDate] = useState(
    moment().add(1, "months").format(DATE_FORMAT_SERVER)
  );
  const [confirmAlertConfig, setConfirmAlertConfig] = useState(
    Object.assign({}, initConfirmAlert)
  );
  const [cancelReason, setCancelReason] = useState(
    Object.assign({}),
    initCancelReason
  );
  const [cancelconfirmConfig, setCancelconfirmConfig] = useState(
    Object.assign({}, initAlertConfig)
  );
  const [deliveryEventLog, setDeliveryEventLog] = useState();

  const [showRateSummary, setShowRateSummary] = useState(false);
  const [custCreditInfo, setCustCreditInfo] = useState();
  const [ordValue, setOrdValue] = useState();
  const [payType, setPayType] = useState("CREDIT");
  const [paymentInitiated, setPaymentInitiated] = useState(false);
  const [cancellationLog, setCancellationLog] = useState();
  const navigate = useNavigate();
  const userType = getUserInfo("userType");
  const [creditUse, setCreditUse] = useState(false);
  const { state } = useLocation();
  const customerId = state?.customerId;
  useEffect(() => {
    fetchDropDownData();
    getCharteredList();
    getCustInfo();
  }, []);

  const fetchPlan = async (argData) => {
    setShowSpinner(true);
    const resp = await CallApiGet(
      `GetCharteredPlanByOrderId?shipmentId=${argData?.orderId}`
    );
    if (resp.respCode === 200) {
      argData.itinArr = resp.respData;
      // setCharteredOrder({
      //   orderId: argData?.orderId,
      //   origin: argData?.origin,
      //   destination: argData?.destination,
      //   shipmentDate: argData?.shipmentDate,
      //   itinArr: resp.respData,
      // });
      setCharteredOrder({ ...argData });
      setShowPlan(true);
    } else {
      handleRespPostApiCall(resp);
    }
    setShowSpinner(false);
  };

  const handlePlanBtnClick = (data) => {
    fetchPlan(data);
  };
  const handleClose = () => {
    setShowPlan(false);
    setSelOrder({});
  };

  const fetchDropDownData = async () => {
    setShowSpinner(true);
    const commObj = Object.assign({}, initDropDownOpt);

    const payload = {
      argVehicle: 1,
      argDriverUser: 1,
    };

    const dropResp = await CallApiPost("GetDropdownOptions", payload);
    const sbuResp = await CallApiGet("getHubAndDepoList");
    if (dropResp.respCode === 200) {
      commObj.drArr = dropResp?.respData?.driverUserArr;
      commObj.vhclArr = dropResp?.respData?.vhclNoArr;
    }
    if (sbuResp.respCode === 200) {
      commObj.sbuArr = sbuResp?.respData?.map((item) => {
        return {
          label: item?.sbuCode + " (" + item?.sbuName + ")",
          value: item?.id,
        };
      });
    }
    setDropDownOpt(Object.assign(commObj));
    setShowSpinner(false);
  };
  const fetchCharteredOrders = async (payload) => {
    setShowSpinner(true);
    let retData = [];
    const uri = "getAllFtlOrders";
    let data = await CallApiPost(uri, payload);
    if (data.respCode === 200) {
      setCharteredList(data.respData);
      retData = data.respData;
    } else {
      console.error(data);
    }
    setShowSpinner(false);
    return retData;
  };

  const getCharteredList = async () => {
    const locToDate = moment()
      .clone()
      .add(1, "months")
      .format(DATE_FORMAT_SERVER);
    const locFromDate = moment()
      .clone()
      .subtract(1, "months")
      .format(DATE_FORMAT_SERVER);
    const payload = {
      searchType: searchType,
      custId: LINEHAUL_CUSTOMER_USER_TYPE_LIST.includes(getUserInfo("userType"))
        ? getUserInfo("acctId")
        : 0,
      toDate: locToDate,
      fromDate: locFromDate,
    };
    setFromDate(locFromDate);
    setToDate(locToDate);
    const orders = await fetchCharteredOrders(payload);
    const page = searchParams.get("page");
    const orderId = searchParams.get("orderId");
    if (page === "ratesummary" && orderId > 0) {
      const filteredObj = orders.find((ord) => ord.orderId === +orderId);
      setSearchParams({});
      openCHOrderBooking("ratesummary", filteredObj);
    }
  };

  const setCharteredOrder = (row) => {
    let tempData = { ...row };
    const isItinPresent =
      Array.isArray(tempData.itinArr) && tempData.itinArr.length > 0;
    if (!isItinPresent) {
      tempData.itinArr = [
        {
          origin: tempData?.origin,
          originId: 0,
          destId: 0,
          destination: tempData?.destination,
          vehicleId: 0,
          driver1: 0,
          driver2: 0,
          sta: "",
          std: "",
        },
      ];
    }

    setSelOrder({ ...tempData });
  };

  const handleRespPostApiCall = (resp, status, msg) => {
    switch (resp.respCode) {
      case 200:
      case 0:
        showAlert({
          isSuccess: true,
          title: "SUCCESS",
          description: !!msg ? msg : resp?.respMessage,
        });
        break;
      case 99:
        showAlert({
          isSuccess: false,
          title: "NETWORK ERROR",
          description: (
            <>
              We're having trouble connecting to the server. <br /> Please check
              your internet connection and try again.
            </>
          ),
        });
        break;
      case 500:
        showAlert({
          isSuccess: false,
          title: "ERROR",
          description:
            "Oops! Something went wrong while processing your request.",
        });
        break;
      default:
        showAlert({
          isSuccess: false,
          title: "ERROR",
          description: !!msg ? msg : resp?.respMessage,
        });
        break;
    }
  };

  const hideAlert = () => {
    setAlertConfig({
      isSuccess: false,
      size: "md",
      show: false,
      title: "",
      description: "",
    });
    getCharteredList();
  };
  const hideCancelConfirmAlert = () => {
    setCancelconfirmConfig({
      isSuccess: false,
      size: "",
      show: false,
      title: "",
      description: "",
    });
    setCancelReason(Object.assign({}, initCancelReason));
  };

  const showAlert = (data) => {
    setAlertConfig({
      isSuccess: data.isSuccess,
      size: "md",
      show: true,
      title: data.title,
      description: data.description,
    });
  };
  const onSumit = () => {
    const payload = {
      searchType: searchType,
      fromDate: moment(fromDate).format(DATE_FORMAT_SERVER),
      toDate: moment(toDate).format(DATE_FORMAT_SERVER),
      custId: LINEHAUL_CUSTOMER_USER_TYPE_LIST.includes(getUserInfo("userType"))
        ? getUserInfo("acctId")
        : 0,
    };
    fetchCharteredOrders(payload);
  };

  const openCharteredDetails = (type, data) => {
    const url = `/charteredOrderDetails?data=${data.orderId}`;
    window.open(url, "_blank");
  };
  const downloadDO = async (data) => {
    setShowSpinner(true);
    document.body.click();
    const uri = "DownloadDO/" + data?.orderId;
    const resp = await CallApiGet(uri);
    if (resp?.respCode === 200 && !!resp?.respData) {
      window.open(resp.respData, "_blank");
    } else {
      if (resp.respCode === 200) {
        resp.respCode = 409;
        resp.respMessage =
          "Sorry, failed to download. Please try after sometime!!";
      }
      handleRespPostApiCall(resp);
    }
    setShowSpinner(false);
  };
  const downloadReceiveQR = async (orderId, qrCode, stopSeq) => {
    setShowSpinner(true);
    document.body.click();
    const uri = `DownloadReceiveQr/${orderId}/${stopSeq}?qrCode=${qrCode}`;
    const resp = await CallApiGet(uri);
    if (resp?.respCode === 200 && !!resp?.respData) {
      window.open(resp.respData, "_blank");
    } else {
      if (resp.respCode === 200) {
        resp.respCode = 409;
        resp.respMessage =
          "Sorry, failed to download. Please try after sometime!!";
      }
      handleRespPostApiCall(resp);
    }
    setShowSpinner(false);
  };

  const getConfirmMsg = (status) => {
    switch (status) {
      case ORD_STS.AWAIT_RATE_CFM:
        return "Do you agree with the offered price?";
      case ORD_STS.AWAIT_QTY_CFM:
        return "Are you sure, you want to confirm the quantity?";
      default:
        return "Are you sure, you want to confirm?";
    }
  };

  const openConfirmAlert = (data) => {
    setSelOrder(Object.assign({}, data));
    setConfirmAlertConfig({
      show: true,
      size: "md",
      title: data?.rate_type === 763 ? "CONFIRM TRIP" : "CONFIRM WEIGHT/PIECES",
      description: getConfirmMsg(data?.statusId),
    });
  };

  const hideConfirmAlert = () => {
    setConfirmAlertConfig(Object.assign({}, initConfirmAlert));
  };

  const confirmAlert = async () => {
    let payload = {
      shipmentId: ordValue?.order_id,
      paymentType: payType === "CASH" && creditUse ? "CASH&ADV" : payType,
      orderType: ordValue?.orderType,
      shipmentDate: moment(
        ordValue?.shipment_date,
        DATE_FORMAT_MOMENT,
        true
      ).format(DATE_FORMAT_SERVER),
      vas: JSON.parse(ordValue?.rate_data),
      insurancePkgId: ordValue?.insurancePkgId,
      status: ordValue?.statusId,
      rateType: ordValue?.rate_type,
    };
    setShowSpinner(true);
    const resp = await CallApiPost(API_URI.CFM_CH_RATE, payload);
    setShowRateSummary(false);
    hideConfirmAlert();
    if (
      resp.respCode === 200 &&
      +resp.respData?.shipmentBilling[0]?.invoiceId > 0 &&
      resp.respData.paymentGateway
    ) {
      setPaymentInitiated(true);
      document.getElementById("paymentForm").innerHTML = getKiplForm(
        resp.respData.paymentGateway,
        resp.respData.shipmentId
      );
      document.getElementById("onlinepayment").submit();
    } else {
      setShowSpinner(false);
      handleRespPostApiCall(resp);
    }
  };
  const isDataValid = (argValue) => {
    if (!!argValue && argValue?.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const cancelShipment = async () => {
    if (!isDataValid(cancelReason.value)) {
      setCancelReason({
        ...cancelReason,
        error: true,
      });
      return;
    }
    setShowSpinner(true);
    const payload = {
      shipmentId: selOrder?.orderId,
      remarks: cancelReason.value,
    };
    const resp = await CallApiPost("CancelChBooking", payload);
    handleRespPostApiCall(resp);
    hideCancelConfirmAlert();
    setShowSpinner(false);

    setShowRateSummary(false);
    setSelOrder({});
  };
  const handleCxlShipment = (row) => {
    setSelOrder(Object.assign({}, row));
    setCancelconfirmConfig({
      isSuccess: true,
      size: "md",
      show: true,
      title: "Cancel Shipment",
      description: "",
    });
  };

  const handleOnChange = (event) => {
    const { value } = event.target;
    let copyCancelReason = Object.assign({}, cancelReason);
    if (!BLACK_SPCL_CHARS.test(value)) {
      copyCancelReason.error = false;
      copyCancelReason.value = value;
      setCancelReason(copyCancelReason);
    }
  };

  const getDeliveryEventLog = async (orderId) => {
    document.body.click();
    setShowSpinner(true);
    let deliveryEventLogData = await deliveryEventlogChartered(orderId);
    setShowSpinner(false);
    if (deliveryEventLogData.respCode === 200) {
      let data = deliveryEventLogData.respData;
      setDeliveryEventLog(data);
    } else if (deliveryEventLogData.respCode === 500) {
      showAlert({
        isSuccess: false,
        title: "",
        description: deliveryEventLogData.respMessage,
      });
    } else {
      setDeliveryEventLog([]);
      localStorage.clear();
      navigate("/home");
    }
  };
  const openCHOrderBooking = (type, data) => {
    setShowRateSummary(true);
    data.order_id = data.orderId;
    data.customer_id = data.customerId;
    setSelOrder(data);
    document.body.click();
  };
  const getCustInfo = async () => {
    if (LINEHAUL_CUSTOMER_USER_TYPE_LIST.includes(userType)) {
      setShowSpinner(true);
      let data = await CallApiGet(`${API_URI.GET_CUST_CREDIT_INFO}`);
      setCustCreditInfo(!!data.respData ? data.respData[0] : []);
      setShowSpinner(false);
    }
  };

  const handelRepeatBooking = async (shipmentId, customerId) => {
    document.body.click();
    setShowSpinner(true);
    let ordDtlsResp = await CallApiGet(
      API_URI.GET_CH_ORD_DTLS + "?ordId=" + shipmentId
    );
    if (ordDtlsResp.respCode === 200 && !!ordDtlsResp?.respData) {
      let data = ordDtlsResp.respData[0];
      data.shipmentTime = data.shipment_time;
      data.route = JSON.parse(data.route);
      data.route.origin = JSON.parse(data.route.origin);
      data.route.destination = JSON.parse(data.route.destination);
      data.route.stops = JSON.parse(data.route.stops)?.filter(
        (st) => !!st.stopSeq
      );
      const rate = JSON.parse(
        data?.orderType === ORDER_TYPE.CHA
          ? data.on_demand_rate_data
          : data.planned_rate_data
      );
      data.route.rateBase = ORDER_TYPE.CHA
        ? rate.filter((rt) => !!rt && rt.serviceId === 0)
        : JSON.parse(data.route.rateBase);
      data.rateData = rate.filter((rt) => !!rt && rt?.serviceId !== 0);
      data.orderInfos = JSON.parse(data.order_info);

      // writeLocalStorage("chBookingData", data)
      //RB: Repeat booking
      navigate("/charteredBooking", {
        state: { navigateFor: CH_NAV_TYPE.RB, bkngData: data },
      });
    } else {
      if (ordDtlsResp.respCode === 200) {
        ordDtlsResp.respCode = 500;
      }
      handleRespPostApiCall(ordDtlsResp);
    }
    setShowSpinner(false);
  };

  const orderCancellationLog = async (orderId) => {
    setShowSpinner(true);
    let cancellationLogData = await CallApiGet(
      `chCancelShipmentAudit/${orderId}`
    );
    setShowSpinner(false);
    if (cancellationLogData.respCode === 200) {
      let data = cancellationLogData.respData;
      setCancellationLog(data);
    } else if (cancellationLogData.respCode === 500) {
      showAlert({
        isSuccess: false,
        title: "",
        description: cancellationLogData.respMessage,
      });
    } else {
      setCancellationLog([]);
      localStorage.clear();
      navigate("/home");
    }
  };

  return (
    <div>
      <Layout
        spinnershow={showSpinner}
        alertConfig={alertConfig}
        hideAlert={hideAlert}
        confirmAlertConfig={confirmAlertConfig}
        hideConfirmAlert={hideConfirmAlert}
        confirmAlert={confirmAlert}
      >
        <div className="clearfix border-bottom pb-2 mb-2">
          <div className="float-start">
            <div className="section-title mt-1">Chartered Orders</div>
          </div>
        </div>
        <section className="w-100">
          <div className="py-1 m-1 d-flex">
            <div className="d-flex col-md-8 text-start">
              <div className="col-auto d-flex align-item-center border rounded p-2 me-3 wt-tbl">
                <div className="col-auto align-self-center me-3">
                  <input
                    className="form-check-input formsty"
                    type="radio"
                    name="filterType"
                    id="inlineRadio1"
                    value="Shipment"
                    checked={searchType === "Shipment" ? true : false}
                    onChange={() => setSearchType("Shipment")}
                  />
                  <label
                    className="form-check-label fw-bold ms-2"
                    htmlFor="inlineRadio1"
                  >
                    Shipment
                  </label>
                </div>
                <div className="col-auto align-self-center me-3">
                  <input
                    className="form-check-input formsty"
                    type="radio"
                    name="filterType"
                    id="inlineRadio2"
                    value="Booking"
                    checked={searchType === "Booking" ? true : false}
                    onChange={() => setSearchType("Booking")}
                  />
                  <label
                    className="form-check-label fw-bold ms-2"
                    htmlFor="inlineRadio2"
                  >
                    Booking
                  </label>
                </div>
                <div className="col-auto align-self-center me-3">
                  <label
                    htmlFor=""
                    className="form-label theme-label me-2"
                    title="This field is mandatory"
                  >
                    From:
                  </label>
                  <ReactDatePicker
                    placeholderText="Select Date"
                    className="form-control"
                    dateFormat={DATE_FORMAT_CLIENT}
                    selected={!!fromDate ? new Date(fromDate) : fromDate}
                    onFocus={(e) => e.target.blur()}
                    onChange={(d) => setFromDate(d)}
                    onSelect={(d) => setFromDate(d)}
                    maxDate={!!toDate ? new Date(toDate) : null}
                  />
                </div>
                <div className="col-auto align-self-center">
                  <label
                    htmlFor=""
                    className="form-label theme-label me-2"
                    title="This field is mandatory"
                  >
                    To:
                  </label>
                  <ReactDatePicker
                    placeholderText="Select Date"
                    className="form-control"
                    dateFormat={DATE_FORMAT_CLIENT}
                    selected={!!toDate ? new Date(toDate) : toDate}
                    onFocus={(e) => e.target.blur()}
                    onChange={(d) => setToDate(d)}
                    onSelect={(d) => setToDate(d)}
                    minDate={!!fromDate ? new Date(fromDate) : null}
                  />
                </div>
              </div>
              <div className="align-self-center">
                <button
                  type="button"
                  className="btn btn-outline-secondary theme-violet text-nowrap"
                  onClick={onSumit}
                  disabled={!(!!fromDate && toDate)}
                >
                  {GetSvgIcon("Search")}
                </button>
              </div>
            </div>
            {LINEHAUL_CUSTOMER_USER_TYPE_LIST.includes(userType) &&
              permissionCheck(CHBKNG, "allowedWrite") && (
                <div className="d-flex col-md-4 justify-content-end">
                  <button
                    className="btn btn-primary theme-violet my-2"
                    onClick={() =>
                      navigate("/charteredBooking", {
                        state: { navigateFor: CH_NAV_TYPE.NB },
                      })
                    } //NB - New Booking
                  >
                    BOOK A CHARTER
                  </button>
                </div>
              )}
          </div>
        </section>
        <CharteredDeliveryEventLog data={deliveryEventLog} />
        <OrderCancellationLog data={cancellationLog} />
        <CharteredOrdersList
          handelRepeatBooking={handelRepeatBooking}
          handlePlanBtnClick={handlePlanBtnClick}
          charteredList={charteredList}
          openCharteredDetails={openCharteredDetails}
          openConfirmAlert={openConfirmAlert}
          downloadDO={downloadDO}
          downloadReceiveQR={downloadReceiveQR}
          handleCxlShipment={handleCxlShipment}
          getDeliveryEventLog={getDeliveryEventLog}
          openCHOrderBooking={openCHOrderBooking}
          orderCancellationLog={orderCancellationLog}
        />
        <CharteredPlanning
          show={showPlan}
          hide={handleClose}
          dropDownOpts={dropDownOpt}
          selOrder={selOrder}
          handleRespPostApiCall={handleRespPostApiCall}
          setShowSpinner={setShowSpinner}
        />
        <CharteredRateSummary
          ChartRateModalConfig={showRateSummary}
          closeChartRateConfig={() => {
            setShowRateSummary(false);
            setSelOrder({});
          }}
          rateOrdDetails={selOrder}
          setShowSpinner={setShowSpinner}
          openConfirmAlert={openConfirmAlert}
          custCreditInfo={custCreditInfo}
          setOrdValue={setOrdValue}
          setPayType={setPayType}
          payType={payType}
          handleCxlShipment={handleCxlShipment}
          openPopup={handleRespPostApiCall}
          creditUse={creditUse}
          setCreditUse={setCreditUse}
        />
        <ModalConfirmAlert
          confirmAlertConfig={cancelconfirmConfig}
          hideConfirmAlert={hideCancelConfirmAlert}
          confirmAlert={cancelShipment}
          cancelBtnTxt="Not now"
          confirmBtnTxt="Cancel order"
        >
          <div className="row">
            <div className="col-md-3">
              <label
                htmlFor="floatingInputGrid"
                className="form-label theme-label"
              >
                Reason <span className="text-danger">&#9733;</span>
              </label>
            </div>
            <div className="col-md-9 mb-2">
              <input
                id="cancellation-reason"
                type="text"
                className="form-control"
                name="cancellationReason"
                value={cancelReason.value}
                autoComplete="false"
                onChange={handleOnChange}
              />
              {cancelReason.error && (
                <div style={{ textAlign: "left" }}>
                  <span className="badge bg-danger">
                    &#9888; This field is required.
                  </span>
                </div>
              )}
            </div>
          </div>
        </ModalConfirmAlert>
        {/* {paymentInitiated && ( */}
        <div id="paymentForm" style={{ display: "none" }}>
          <div className="py-5">
            <center>
              <h3 className="text-danger">
                Please Wait. Payment is in progress...
              </h3>
              <h5 className="text-danger">
                Do not click any button or refresh the page.
              </h5>
            </center>
          </div>
        </div>
        {/* )} */}
      </Layout>
    </div>
  );
};

export default CharteredOrdersMain;
